import { Component } from '@angular/core';

@Component({
    selector: 'otb-skeleton-loader-main',
    templateUrl: './skeleton-loader-main.component.html',
    styleUrls: ['./skeleton-loader-main.component.scss'],
    standalone: false,
})
export class SkeletonLoaderMainComponent {}
